module.exports = __webpack_public_path__ + "static/media/block.b2c11d41.svg";